import { matchPath } from 'react-router-dom'

class RouteMatcher {
  
  constructor( routes, miss ) {
    this.routes = routes
    this.miss = miss
  }
  
  find( location ) {
    let match = null
    let matchIndex = null

    this.routes.some( ( route, index ) => {
      const { path, exact } = route.props
      matchIndex = index
      match = matchPath( location.pathname, { exact : !!exact, path } )
      return !!match
    } )

    return { match, matchIndex, location }
  }
}

export default RouteMatcher
